import React, { useState } from 'react';

interface Props {
    title: string;
    children: React.ReactNode;
}

// Hopfällbar inställningsruta med rubrikknapp, används på gateway-sidan.
const CollapsiblePanel: React.FC<Props> = ({ title, children }) => {
    const [open, setOpen] = useState(false);
    return (
        <div style={{ marginBottom: '20px', border: '1px solid #dee2e6', borderRadius: '6px', overflow: 'hidden' }}>
            <button type="button" onClick={() => setOpen(o => !o)}
                style={{ width: '100%', background: '#e8f0fe', border: 'none', padding: '10px 14px', cursor: 'pointer', textAlign: 'left', fontWeight: 'bold', fontSize: '13px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span>{title}</span>
                <span>{open ? '▲' : '▼'}</span>
            </button>
            {open && (
                <div style={{ padding: '14px 16px', background: '#f0f4ff', display: 'flex', alignItems: 'flex-end', gap: '20px', flexWrap: 'wrap' }}>
                    {children}
                </div>
            )}
        </div>
    );
};

export default CollapsiblePanel;
